<div *ngIf="decision === 'accepted'"
  class="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#faf5ff] to-[#e1d5fa] p-4">
  <div class="max-w-md w-full p-8 text-center bg-white shadow-xl rounded-lg">
    <div class="flex justify-center mb-4">
      <svg class="w-16 h-16 text-[#16a34a]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
    </div>
    <h2 class="text-2xl font-bold text-[#1e1b4b] mb-2">Thank You!</h2>
    <p class="text-[#6b7280] mb-4">You have accepted the Privacy Policy. Redirecting you now...</p>
  </div>
</div>

<div *ngIf="decision === 'declined'"
  class="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#faf5ff] to-[#e1d5fa] p-4">
  <div class="max-w-md w-full p-8 text-center bg-white shadow-xl rounded-lg">
    <div class="flex justify-center mb-4">
      <svg class="w-16 h-16 text-[#dc2626]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
        stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
    </div>
    <h2 class="text-2xl font-bold text-[#1e1b4b] mb-2">Policy Declined</h2>
    <p class="text-[#6b7280] mb-6">
      You have declined the Privacy Policy. You will not be able to use our services without accepting the policy.
    </p>
    <button (click)="reviewAgain()" class="bg-[#4c1d95] hover:bg-[#5b21b6] text-white font-semibold py-2 px-4 rounded">
      Review Again
    </button>
  </div>
</div>

<div *ngIf="!decision" class="min-h-screen bg-gradient-to-br from-[#faf5ff] to-[#e1d5fa] py-8 px-4 sm:px-6 lg:px-8">
  <div class="max-w-4xl mx-auto">
    <!-- Header -->
    <div class="text-center mb-8">
      <div class="flex items-center justify-center mb-4">
        <div class="bg-[#4c1d95] p-3 rounded-full">
          <svg class="w-8 h-8 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
      </div>
      <h1 class="text-4xl font-bold text-[#1e1b4b] mb-2">Privacy Policy</h1>
      <p class="text-[#6b7280] text-lg">Litspeed Limited</p>
      <p class="text-sm text-[#6b7280] mt-2">Last Updated: January 2025</p>
    </div>

    <!-- Download Button -->
    <div class="flex justify-end mb-4">
      <button (click)="handleDownload()"
        class="border-[#4c1d95] text-[#4c1d95] hover:bg-[#e1d5fa] bg-transparent border font-semibold py-2 px-4 rounded flex items-center">
        <svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
        </svg>
        Download Policy
      </button>
    </div>

    <!-- Policy Content Card -->
    <div class="bg-white shadow-xl mb-6 rounded-lg">
      <div class="h-[500px] p-6 sm:p-8 overflow-y-auto" (scroll)="handleScroll($event)">
        <div id="privacy-content" class="prose prose-sm sm:prose max-w-none">
          <div class="space-y-6 text-[#1e1b4b]">
            <section>
              <p class="text-base leading-relaxed">
                Litspeed Limited ("Litspeed", "we", "us", "our" or "the Company") recognises your fundamental right
                to privacy as enshrined under the Kenyan Data Protection Act, 2019, the EU General Data Protection
                Regulation (GDPR), where applicable, and other relevant data protection laws. As a law-abiding and
                regulated financial technology (FinTech) service provider, it is our priority to ensure that your
                Personal Data is collected, processed, and protected in compliance with all applicable laws and
                regulations.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Definitions</h2>
              <h3 class="text-xl font-semibold text-[#4c1d95] mt-4 mb-2">Data / Personal Information</h3>
              <p class="mb-2">
                Refers to any data that identifies you directly or indirectly, including but not limited to:
              </p>
              <ul class="list-disc pl-6 space-y-1 text-[#1e1b4b]">
                <li>Name, ID/passport number, phone number, email address, address</li>
                <li>Account credentials, PINs, passwords, and transaction information</li>
                <li>Photographs, location data, online identifiers (IP, MAC, IMEI, IMSI)</li>
                <li>Financial and biometric data</li>
                <li>Demographic attributes such as date of birth, gender, religion, nationality, race/tribe</li>
                <li>Sensitive identifiers (e.g., political opinions, union membership, health records, criminal history)
                </li>
              </ul>
              <h3 class="text-xl font-semibold text-[#4c1d95] mt-4 mb-2">Processing / Process</h3>
              <p>
                Refers to any operation performed on your personal data, either manually or through automated means.
                This includes collection, recording, structuring, storage, retrieval, usage, disclosure, alignment,
                restriction, erasure, or destruction of data.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Consent</h2>
              <p>
                We kindly ask that you review this Policy carefully and, where applicable, provide your consent by
                clicking ' Agree' or any other opt-in feature provided. By continuing to interact with our platforms
                and services, you expressly consent to the terms of this Policy, particularly regarding the
                collection and processing of your personal data.
              </p>
              <p class="mt-2">
                Your consent may be withdrawn at any time, subject to applicable laws and contractual obligations,
                without affecting the lawfulness of processing carried out prior to the withdrawal.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Age Eligibility</h2>
              <p>
                To access and use our services or any of our Platforms, you must be at least 18 years old or the
                legal age of majority in your jurisdiction.
              </p>
              <p class="mt-2">
                Individuals under the age of 18 may only use our services with the direct involvement of a parent or
                legal guardian, and such use must occur under the guardian's registered account.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Collection of Personal Data</h2>
              <p class="mb-3">
                In the course of your interactions with Litspeed Limited, whether directly or via third parties
                through our Platforms, we may collect your personal data in the following ways:
              </p>
              <h3 class="text-lg font-semibold text-[#4c1d95] mb-2">a) Automatic Data Collection</h3>
              <p class="mb-3">
                We may automatically collect certain data when you interact with our Platforms through cookies, web
                beacons, and API calls. This information helps us enhance your experience, personalize content, and
                improve platform security.
              </p>
              <h3 class="text-lg font-semibold text-[#4c1d95] mb-2">b) Device and Location Information</h3>
              <p class="mb-3">
                When you download or use our digital platforms, we may receive location and device-specific data,
                such as IP address, device ID, operating system, and browser type.
              </p>
              <h3 class="text-lg font-semibold text-[#4c1d95] mb-2">c) Information You Provide</h3>
              <p class="mb-3">
                We collect information directly from you when you create or update an account, submit identification
                documents, interact with us via email, or participate in promotions.
              </p>
              <h3 class="text-lg font-semibold text-[#4c1d95] mb-2">d) Information from Third Parties</h3>
              <p class="mb-3">
                We may receive personal data about you from third-party sources, including financial institutions,
                agents, vendors, employers, or public authorities, as permitted by law.
              </p>
              <h3 class="text-lg font-semibold text-[#4c1d95] mb-2">e) Social Media Interactions</h3>
              <p>
                When you engage with us via social media platforms, we may collect any publicly available or
                provided information from those interactions.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Use of Personal Data</h2>
              <p class="mb-2">We collect and process your personal data for the following lawful purposes:</p>
              <ul class="list-disc pl-6 space-y-1 text-[#1e1b4b]">
                <li>To provide, operate, and maintain our services and digital platforms</li>
                <li>To create and manage user accounts and facilitate onboarding</li>
                <li>To process transactions and send related confirmations or notifications</li>
                <li>To verify your identity, especially during account creation and KYC processes</li>
                <li>To offer responsive customer support and improve user satisfaction</li>
                <li>To detect, investigate, and prevent fraud, financial crime, and system abuse</li>
                <li>To enforce our terms of use, policies, and applicable user agreements</li>
                <li>To personalize services, marketing, and communication based on your preferences</li>
                <li>To fulfill legal, regulatory, or contractual obligations</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Storage and Protection of Your Data</h2>
              <p class="mb-3">
                We are committed to ensuring the security, integrity, and confidentiality of your personal data. We
                employ a layered approach to data protection using physical, technical, and administrative
                safeguards.
              </p>
              <p class="mb-2">Our security measures include:</p>
              <ul class="list-disc pl-6 space-y-1 text-[#1e1b4b]">
                <li>Data encryption (both at rest and in transit)</li>
                <li>Secure cloud infrastructure and access-controlled physical storage locations</li>
                <li>Multi-factor authentication and role-based access controls</li>
                <li>Regular system audits, vulnerability scans, and access reviews</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Your Rights</h2>
              <p class="mb-2">As a data subject, you are entitled to the following rights:</p>
              <ul class="list-disc pl-6 space-y-2 text-[#1e1b4b]">
                <li><strong>Right of Access:</strong> Request access to the personal data we hold about you</li>
                <li><strong>Right to Data Portability:</strong> Request your data in a commonly used electronic format
                </li>
                <li><strong>Right to Rectification:</strong> Request correction of inaccurate or incomplete data</li>
                <li><strong>Right to Withdraw Consent:</strong> Withdraw your consent to data processing at any time
                </li>
                <li><strong>Right to Restrict or Object:</strong> Restrict or object to the processing of your data</li>
                <li><strong>Right to Erasure:</strong> Request deletion of your personal data (subject to legal
                  obligations)</li>
                <li><strong>Right to Lodge a Complaint:</strong> File a complaint with the Office of the Data Protection
                  Commissioner (ODPC)</li>
              </ul>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Cookie Policy</h2>
              <p class="mb-3">
                Cookies are small data files stored on your device when websites are loaded. We use cookies to
                recognize you as a returning user, personalize content, measure effectiveness, strengthen security,
                and improve trust and usability.
              </p>
              <h3 class="text-lg font-semibold text-[#4c1d95] mb-2">Types of Cookies We Use</h3>
              <ul class="list-disc pl-6 space-y-1 text-[#1e1b4b] mb-3">
                <li><strong>Session Cookies:</strong> Active only during your browsing session</li>
                <li><strong>Persistent Cookies:</strong> Remain on your device to remember preferences for future visits
                </li>
              </ul>
              <p>
                You have full control over your cookie settings and can accept, reject, or disable cookies via your
                browser settings. Note that disabling cookies may limit access to certain features.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Data Retention</h2>
              <p class="mb-3">
                We retain data only for as long as necessary to fulfill business, legal, and regulatory obligations.
                Retention periods are determined by statutory requirements, contractual agreements, and operational
                needs.
              </p>
              <p>
                Once the retention period expires, records are securely deleted, shredded, or anonymized to prevent
                unauthorized recovery or access.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Third-Party Data Sharing</h2>
              <p class="mb-3">
                We may share your personal data with trusted third-party partners, including service providers,
                financial institutions, vendors, and technology partners to support service delivery and operations.
              </p>
              <p class="mb-3">
                We may also disclose your data to regulators, law enforcement, or government agencies where required
                by law or necessary to protect our legal rights and the safety of our clients.
              </p>
              <p>
                All third parties receiving your data must commit to adequate security measures and confidentiality
                obligations.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Cross-Border Data Transfer</h2>
              <p>
                Your personal data may be transferred or stored in locations outside Kenya. We ensure all
                cross-border transfers comply with the Kenyan Data Protection Act, 2019, GDPR, and other applicable
                laws, with appropriate safeguards in place.
              </p>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Contact Us</h2>
              <div class="bg-[#faf5ff] p-4 rounded-lg border border-[#e1d5fa]">
                <p class="font-semibold text-[#4c1d95] mb-2">Litspeed Limited – Data Protection Officer</p>
                <p class="text-sm">Nairobi, Kenya</p>
                <p class="text-sm">
                  Email: <a href="mailto:dpo&#64;litspeed.com"
                    class="text-[#a855f7] hover:underline">dpo&#64;litspeed.com</a>
                </p>
                <p class="text-sm">Phone: +254 726 00 00 42</p>
                <p class="text-sm">
                  Website: <a href="https://www.litspeed.co.ke/privacy"
                    class="text-[#a855f7] hover:underline">www.litspeed.co.ke/privacy</a>
                </p>
              </div>
            </section>

            <section>
              <h2 class="text-2xl font-bold text-[#4c1d95] mb-3">Amendments to this Policy</h2>
              <p>
                This Policy may be updated from time to time. All changes will be published on our official website
                and will take effect immediately upon publication. Continued use of our platforms following an
                update constitutes your acceptance of the revised terms.
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>

    <!-- Scroll Indicator -->
    <div *ngIf="!hasScrolledToBottom" class="text-center mb-4">
      <p class="text-sm text-[#6b7280] animate-pulse">
        Please scroll to the bottom to enable the action buttons
      </p>
    </div>

    <!-- Action Buttons -->
    <div class="bg-white shadow-xl p-6 rounded-lg">
      <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
        <button (click)="handleDecline()" [disabled]="!hasScrolledToBottom"
          class="w-full sm:w-auto min-w-[150px] border-[#dc2626] text-[#dc2626] hover:bg-[#dc2626] hover:text-white disabled:opacity-50 disabled:cursor-not-allowed bg-transparent border font-semibold py-2 px-4 rounded flex items-center justify-center">
          <svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
          Decline
        </button>
        <button (click)="handleAccept()" [disabled]="!hasScrolledToBottom"
          class="w-full sm:w-auto min-w-[150px] bg-[#4c1d95] hover:bg-[#5b21b6] text-white disabled:opacity-50 disabled:cursor-not-allowed font-semibold py-2 px-4 rounded flex items-center justify-center">
          <svg class="w-4 h-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
          </svg>
          Accept & Continue
        </button>
      </div>
      <p class="text-xs text-center text-[#6b7280] mt-4">
        By clicking "Accept & Continue", you agree to our Privacy Policy and consent to the collection and
        processing of your personal data as described above.
      </p>
    </div>

    <!-- Footer -->
    <div class="text-center mt-8 text-sm text-[#6b7280]">
      <p>© 2025 Litspeed Limited. All rights reserved.</p>
    </div>
  </div>
</div>